// mixins/schoolYearsMixin.js
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('lookups', [
      'pidSchoolYearsDesc',
    ]),
    schoolYears() {
      const today = new Date();
      const toISO = d => d.toISOString().split('T')[0];
      const parseMD = (s) => {
        const [m, d] = s.trim().split('/').map(Number);
        return new Date(today.getFullYear(), m - 1, d);
      };

      const ruleCurrentYear = Number(this.properties['RULE-CURRENT_SCHOOL_YEAR']);
      const schoolYearsAllowed = this.properties['RULE-SCHOOL_YEARS_ALLOWED'];
      const pidSchoolYears = this.pidSchoolYearsDesc;

      if (schoolYearsAllowed === 'Current Year Only') {
        return pidSchoolYears.filter(a => Number(a.year) === ruleCurrentYear);
      }

      if (schoolYearsAllowed === 'Current Year With Prior Year Overlap') {
        const years = [];
        const current = pidSchoolYears.find(a => Number(a.year) === ruleCurrentYear);
        if (current) years.push(current);

        const overlapStart = parseMD(this.properties['RULE-PRIOR_YEAR_OVERLAP_START_DATE']);

        const schoolYearStart = parseMD(this.properties['RULE-YEAR_START_MONTH_DAY']);
        const schoolYearStartBefore = new Date(schoolYearStart);
        schoolYearStartBefore.setDate(schoolYearStartBefore.getDate() - 1);

        const overlapEndMD = this.properties['RULE-PRIOR_YEAR_OVERLAP_END_DATE'].trim().split('/').map(Number);
        const overlapEnd = new Date(schoolYearStartBefore
          .getFullYear(), overlapEndMD[0] - 1, overlapEndMD[1]);

        if (toISO(overlapStart) <= toISO(today) && toISO(today) <= toISO(overlapEnd)) {
          const prior = pidSchoolYears.find(a => Number(a.year) === ruleCurrentYear - 1);
          if (prior) years.push(prior);
        }

        return years;
      }

      return pidSchoolYears;
    },
  },
};
